var _linearGradient, _linearGradient2, _path, _path2, _path3, _linearGradient3, _path4, _linearGradient4, _path5, _linearGradient5, _path6, _linearGradient6, _path7, _linearGradient7, _path8, _linearGradient8, _path9, _linearGradient9, _path10, _linearGradient10, _path11, _linearGradient11, _path12, _linearGradient12, _path13, _linearGradient13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountingJournal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1",
    gradientUnits: "userSpaceOnUse",
    x1: -1366.351,
    y1: -1210.179,
    x2: -1365.351,
    y2: -1210.179
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1",
    gradientUnits: "userSpaceOnUse",
    x1: 72.245,
    y1: 132.331,
    x2: 144.804,
    y2: 132.331
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M73.495 132.331h70.059"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M110.497 56.497s-.768-4.443-4.443-4.443-4.662 4.443-4.662 4.443l9.544 7.236M101.83 63.733s.768 4.443 4.443 4.443 4.662-4.443 4.662-4.443M106.164 48.269v3.785M106.164 68.176v3.785"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M143.554 132.331V29.06H61.743v12.082M61.743 74.682V66.65M61.743 108.081v-7.54M61.743 132.331V117M61.743 91.622v-8.021M61.743 57.731V50.06"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1",
    gradientUnits: "userSpaceOnUse",
    x1: 53.621,
    y1: 62.191,
    x2: 68.704,
    y2: 62.191
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.454 62.185c0 1.741-2.925 4.519-6.53 4.519-3.616 0-6.053-2.024-6.053-4.519 0-2.484 2.437-4.509 6.053-4.509 3.605.001 6.53 2.776 6.53 4.509z",
    fill: "none",
    stroke: "url(#SVGID_2_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1",
    gradientUnits: "userSpaceOnUse",
    x1: 53.621,
    y1: 45.606,
    x2: 68.704,
    y2: 45.606
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.454 45.601c0 1.741-2.925 4.519-6.53 4.519-3.616 0-6.053-2.024-6.053-4.519 0-2.484 2.437-4.509 6.053-4.509 3.605 0 6.53 2.775 6.53 4.509z",
    fill: "none",
    stroke: "url(#SVGID_3_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1",
    gradientUnits: "userSpaceOnUse",
    x1: 53.621,
    y1: 79.139,
    x2: 68.704,
    y2: 79.139
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.454 79.133c0 1.741-2.925 4.519-6.53 4.519-3.616 0-6.053-2.024-6.053-4.519 0-2.484 2.437-4.509 6.053-4.509 3.605.001 6.53 2.776 6.53 4.509z",
    fill: "none",
    stroke: "url(#SVGID_4_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1",
    gradientUnits: "userSpaceOnUse",
    x1: 53.621,
    y1: 96.086,
    x2: 68.704,
    y2: 96.086
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.454 96.081c0 1.741-2.925 4.519-6.53 4.519-3.616 0-6.053-2.024-6.053-4.519 0-2.484 2.437-4.509 6.053-4.509 3.605 0 6.53 2.776 6.53 4.509z",
    fill: "none",
    stroke: "url(#SVGID_5_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1",
    gradientUnits: "userSpaceOnUse",
    x1: 53.621,
    y1: 112.54,
    x2: 68.704,
    y2: 112.54
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.454 112.534c0 1.741-2.925 4.519-6.53 4.519-3.616 0-6.053-2.024-6.053-4.519 0-2.484 2.437-4.509 6.053-4.509 3.605.001 6.53 2.776 6.53 4.509z",
    fill: "none",
    stroke: "url(#SVGID_6_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1",
    gradientUnits: "userSpaceOnUse",
    x1: 66.204,
    y1: 53.893,
    x2: 72.329,
    y2: 53.893
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.454 62.185s8.157-8.428 0-16.585",
    fill: "none",
    stroke: "url(#SVGID_7_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1",
    gradientUnits: "userSpaceOnUse",
    x1: 66.204,
    y1: 37.313,
    x2: 72.329,
    y2: 37.313
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.454 45.606s8.157-8.428 0-16.585",
    fill: "none",
    stroke: "url(#SVGID_8_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1",
    gradientUnits: "userSpaceOnUse",
    x1: 66.204,
    y1: 70.846,
    x2: 72.329,
    y2: 70.846
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.454 79.139s8.157-8.428 0-16.585",
    fill: "none",
    stroke: "url(#SVGID_9_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1",
    gradientUnits: "userSpaceOnUse",
    x1: 66.204,
    y1: 87.799,
    x2: 72.329,
    y2: 87.799
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.454 96.092s8.157-8.428 0-16.585",
    fill: "none",
    stroke: "url(#SVGID_10_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1",
    gradientUnits: "userSpaceOnUse",
    x1: 66.204,
    y1: 104.379,
    x2: 72.329,
    y2: 104.379
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.454 112.671s8.157-8.428 0-16.585",
    fill: "none",
    stroke: "url(#SVGID_11_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1",
    gradientUnits: "userSpaceOnUse",
    x1: 66.206,
    y1: 119.33,
    x2: 72.326,
    y2: 119.33
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.456 112.535l.066.066c5.067 5.132 3.721 10.363 2.024 13.526",
    fill: "none",
    stroke: "url(#SVGID_12_196ae711441c893c03b678944e0cb039349a420c7f7a923e9e17d30bfe048bd1)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M143.549 126.124H67.951c-3.416 0-6.211 2.795-6.211 6.211 0 3.416 2.795 6.211 6.211 6.211h75.598v-12.422zM120.585 79.139H91.742c-5.457 0-9.921-4.465-9.921-9.921V51.013c0-5.457 4.465-9.921 9.921-9.921h28.843c5.457 0 9.921 4.465 9.921 9.921v18.204c0 5.457-4.464 9.922-9.921 9.922z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountingJournal);
export default __webpack_public_path__ + "static/media/accountingJournal.2d2dc4bc63a98ef6fad5fa4363a29228.svg";
export { ForwardRef as ReactComponent };